import { Auto, ManualBlack, ChevronDown, ChevronUp } from '../Icons/CustomIcons';
import { useState } from 'react';

const OPTIONS = [
  {
    id: 'auto',
    icon: <Auto size={20} style={{ color: 'var(--Color-Black)' }} />,
    label: 'Automatisch',
    description: '(Von Website geladen)'
  },
  {
    id: 'manual',
    icon: <ManualBlack size={20} style={{ color: 'var(--Color-Black)' }} />,
    label: 'Manuell',
    description: '(Manuelle Eingabe)'
  },
];

const OpeningHoursSelect = ({ onChange, initialValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    () => OPTIONS.find(o => o.id === initialValue) ?? OPTIONS[0]
  );

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    onChange?.(option.id);
  };

  return (
    <div className="oh-container">
      <h3 className="body Font-M-S-130-T Colors-Black">Öffnungszeiten</h3>

      {/* Trigger */}
      <div
        className={`oh-trigger ${isOpen ? 'oh-trigger--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="oh-icon">{selected.icon}</div>
        <span className="oh-label">
          {selected.label}
          <span className="oh-description"> {selected.description}</span>
        </span>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="oh-dropdown">
          {OPTIONS.map((option) => (
            <div
              key={option.id}
              className={`oh-option ${option.id === selected.id ? 'oh-option--selected' : ''}`}
              onClick={() => handleSelect(option)}
            >
              <div className="oh-icon">{option.icon}</div>
              <span className="oh-label">
                {option.label}
                <span className="oh-description"> {option.description}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OpeningHoursSelect;